import { IconContainer } from '@/components/icons';
import { ComingSoonBadge } from '@/lib';
import { ComponentProps, FC } from 'react';

type DataSourceComingSoonCardProps = {
  icon: ComponentProps<typeof IconContainer>['icon'];
  title: string;
};

export const DataSourceComingSoonCard: FC<DataSourceComingSoonCardProps> = ({ icon, title }) => {
  return (
    <div className='flex w-full cursor-not-allowed flex-wrap items-center justify-between gap-4 rounded-xl border border-quaternary-300 bg-white-100 p-4 shadow lg:flex-nowrap'>
      <div className='flex flex-wrap items-center gap-3 lg:flex-nowrap'>
        <IconContainer icon={icon} className='h-12' />
        <p className='text-base font-medium text-gray-900 first-letter:capitalize'>{title}</p>
      </div>
      <ComingSoonBadge className='sm:shrink-0 lg:shrink xl:shrink-0' />
    </div>
  );
};
